import {
  differenceInDays,
  differenceInHours,
  differenceInMinutes,
  differenceInMonths,
  differenceInYears,
  isThisHour,
  isThisMinute,
  isThisMonth,
  isThisYear,
  isToday,
  isYesterday
} from 'date-fns'
import { NotificationItem } from '../types/Notification.type'

export function timeDiff(timestamp: string) {
  if (isThisMinute(timestamp)) return 'Just now'
  if (isThisHour(timestamp)) return differenceInMinutes(new Date(), timestamp) + 'm ago'
  if (isToday(timestamp)) return differenceInHours(new Date(), timestamp) + 'h ago'
  if (isThisMonth(timestamp)) return differenceInDays(new Date(), timestamp) + 'd ago'
  if (isThisYear(timestamp)) return differenceInMonths(new Date(), timestamp) + 'months ago'
  return differenceInYears(new Date(), timestamp) + 'years ago'
}

export function groupNotifByDate(data: NotificationItem[]) {
  return Object.entries(
    data.reduce((acc: any, notif) => {
      const dateKey = isToday(notif.timestamp)
        ? 'Today'
        : isYesterday(notif.timestamp)
          ? 'Yesterday'
          : new Date(notif.timestamp).toLocaleDateString()

      // group initialization
      if (!acc[dateKey as keyof typeof acc]) {
        acc[dateKey] = []
      }
      acc[dateKey as keyof typeof acc].push(notif)

      return acc
    }, {})
  ).map(([date, data]) => ({ date, data }) as { date: string; data: NotificationItem[] })
}
